var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var LockLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.5C9 4.496 10.342 3 12 3s3 1.496 3 3.5V9H9V6.5ZM8 9V6.5C8 4.086 9.657 2 12 2c2.342 0 4 2.086 4 4.5V9h.5a3.5 3.5 0 0 1 3.5 3.5v6a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 4 18.5v-6A3.5 3.5 0 0 1 7.5 9H8Zm0 1h-.5A2.5 2.5 0 0 0 5 12.5v6A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5v-6a2.5 2.5 0 0 0-2.5-2.5H8Zm1.5 4a2.5 2.5 0 1 1 4 2v2a1.5 1.5 0 0 1-3 0v-2a2.496 2.496 0 0 1-1-2Zm2.5-1.5a1.5 1.5 0 0 0-.75 2.8.5.5 0 0 1 .25.432V18a.5.5 0 0 0 1 0v-2.268a.5.5 0 0 1 .25-.432 1.5 1.5 0 0 0-.75-2.8Z",
    fill: "currentColor"
  }));
});
LockLg.displayName = "LockLg";
export default LockLg;